import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import BlogPostPage from "./components/BlogPostPage";
import BlogListPage from "./components/BlogListPage";
import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/blog" element={<BlogPostPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/blog/all" element={<BlogListPage />} />
      </Routes>
    </Router>
  );
}

export default App;
